import { css } from '@emotion/react';

export const root = css`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0;
  z-index: var(--zindex-modal);
`;

export const overlay = css`
  position: absolute;
  inset: 0;
  z-index: -1;
  background: rgba(48, 48, 51, 0.3);
  cursor: pointer;
`;

export const content = (isWidth: boolean, isMinWidth: boolean) => css`
  ${!isWidth && 'width: 51.2rem;'}
  ${isMinWidth && 'min-width: 51.2rem;'}
  border-radius: 0.6rem;
  background: var(--color-white);
  max-width: calc(100vw - 40px);
`;

export const header = (alignHeader = 'center') => css`
  display: flex;
  align-items: center;
  padding: 2.4rem 2.4rem 0rem 2.4rem;
  line-height: 1.23;
  text-align: ${alignHeader};
`;

export const title = (fontSize = '2.5rem') => css`
  flex: 1;
  font-size: ${fontSize};
  font-weight: 700;
  @media (max-width: 400px) {
    font-size: 2.1rem;
  }
`;

export const closeButton = css`
  width: 3rem;
  height: 3rem;
  line-height: 1;
  > svg {
    vertical-align: middle;
  }
`;

export const body = css`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  padding: 1.6rem 2.4rem 0.8rem;
  max-height: 62.5vh;
  overflow: auto;
`;

export const text = css`
  font-size: 1.6rem;
`;

export const footer = css`
  display: flex;
  justify-content: flex-end;
  gap: 1.6rem;
  padding: 1.2rem 1.6rem;
`;

export const helperText = css`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-left: 10px;
`;
